export enum EnumPaymentMethod {
  CREDIT_CARD = "CREDIT_CARD",
  BANK_TRANSFER = "BANK_TRANSFER",
  QR_PROMPTPAY = "QR_PROMPTPAY",
  MONTHLY_CREDIT_CARD = "MONTHLY_CREDIT_CARD",
  MONTHLY_BANK_KBANK = "KBank",
  MONTHLY_BANK_KTB = "KTB",
  MONTHLY_BANK_SCB = "SCB",
}
